'use client';
interface TextButtonProps {
  label: string;
  onClick: () => void;
  className?: string; // Tailwind에서 disabled: 및 enabled: variant 사용 가능
  disabled?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const TextButton = ({ label, onClick, className, disabled, onMouseEnter, onMouseLeave }: TextButtonProps) => {
  return (
    <button onClick={onClick} className={className} disabled={disabled} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {label}
    </button>
  );
};

export default TextButton;
